import React, { type RefObject, useRef } from 'react'
// reason: FIXME at moment we rely too much on custom styling, we need all accessibilites from menu item but own styling
// eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
import { Button } from '@mui/material'

type Props = {
  inputRef: RefObject<HTMLDivElement | null>
  label?: string
}

/**
 * On Focus show option to skip to the first interactive element in your given inputRef
 * FIXME: maybe candidate for more usecases and a generic component, and maybe this is not a Button (too much customization)
 */
export const Skip = ({ inputRef, label = '' }: Props) => {
  const buttonRef = useRef<HTMLAnchorElement>(null)

  const handleClick = () => {
    if (buttonRef.current) {
      buttonRef.current.blur()
    }

    setTimeout(() => {
      if (inputRef.current) {
        const focusableElements = Array.from(
          inputRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        ).filter((el) => (el as HTMLElement).offsetParent !== null && !(el as HTMLInputElement).disabled)

        if (focusableElements.length > 0) {
          ;(focusableElements[0] as HTMLElement).focus()
        }
      }
    }, 100)
  }

  return (
    <Button
      ref={buttonRef}
      component="a"
      variant="text"
      onClick={handleClick}
      size="small"
      sx={{
        // FIXME: at moment we do not have buttons with a background, maybe this usecase is not a button at all :)
        backgroundColor: 'pure.light',
        width: '1px',
        height: '1px',
        position: 'absolute',
        top: 10,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        clip: 'rect(0px, 0px, 0px, 0px)',
        overflow: 'hidden',
        '&:focus': {
          width: 'auto',
          height: 'inherit',
          margin: 0,
          clip: 'unset',
          overflow: 'unset',
        },
      }}
      // reason: for now plain english for a11y
      // eslint-disable-next-line @dhl/generic/no-hardcoded-translations
    >
      Skip {label}
    </Button>
  )
}
